import { PATHS } from "@constants/Paths";
export const reportSettingsTopicsPath = (reportId) => PATHS.REPORT_SETTINGS_TOPICS.replace(":reportId", reportId);
export const reportSettingsCompetitorsPath = (reportId) => PATHS.REPORT_SETTINGS_COMPETITORS.replace(":reportId", reportId);
// The report's categories and the settings tabs are two vocabularies for the same four groups;
// Price & Layout is one tab covering both of the report's unit and price categories.
const SUBTOPIC_TAB_BY_CATEGORY = {
    location: "location",
    amenity: "amenities",
    commute: "commute",
    price: "price-layout",
    unit: "price-layout",
};
export const reportSettingsCategoryPath = (reportId, categoryType) => {
    const tab = categoryType ? SUBTOPIC_TAB_BY_CATEGORY[categoryType] : undefined;
    const path = reportSettingsTopicsPath(reportId);
    return tab ? `${path}?subtopicTab=${tab}` : path;
};
